<template>
    <div>
        <q-score-card key="QScoreCardNewRecruits" ref="card" title="Ready to Write" api-endpoint="new_recruits" drill-down-label="Ready to Write" drill-down-route="Drilldown_NewRecruits" card-style="recruiting" :agent-code="agentCode" :filters="filters" v-on:most_current="updateMostCurrent">
            Note: This is the number of licensed agents onboarding in the given month. Only agents with an NPN number are included - does not include active unlicensed agents.
        </q-score-card>
    </div>
</template>
<script>
import QScoreCard from "./QScoreCard.vue";

export default {
    name: "QScoreCardNewRecruits",
    props: ["agentCode", "filters"],
    data: function() { // data internal to component (not available outside)
        return {

        }
    },
    mounted: function() {},
    computed: {

    },
    methods: {
        updateMostCurrent: function(most_current) {
            this.$emit('most_current', most_current);
        }
    },
    watch: {

    },
    components: {
        QScoreCard,
    }
}

</script>
<style scoped>
</style>
